import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatChipInputEvent } from '@angular/material/chips';
import { lastValueFrom } from 'rxjs';
import { ProductsService } from 'src/app/shared/service/product.service';
import * as Notiflix from 'notiflix';
import { DomSanitizer } from '@angular/platform-browser';
import { APIService } from 'src/app/shared/service/apiService.service';

export interface nombreCursos {
  name: string;
}

@Component({
  selector: 'app-new-product',
  templateUrl: './new-product.component.html',
  styleUrl: './new-product.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class NewProductComponent {
  public isButtonDisabled: boolean = true;  // Inicialmente deshabilitado
  @Input() productId;
  public ImgfileName = '';
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  public categorySelected = null;
  public levelSelected = null;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  public responseImgFile: string = '';
  @Input() previewImg: any;  // 🔥 NUEVO: Recibir imagen de preview del padre
  public viewLoaderImg = false;
  public viewLoaderFile = false;
  public previewFile: any;
  file: File;
  public responseFile: string = '';
  imagesX: File[] = [];
  @Input() course!: any;  // aquí recibes el mismo objeto del padre
  @Input() requireAllFields: boolean = false; // permite que el componente padre pase un valor a este componente hijo.
  @Input() learning: any[] = [];
  @Input() target: any[] = [];
  @Input() newImageSelected: boolean = false;
  @Input()imgFileUrl: string = '';
  @Input() modulos: any[] = [];


  // public course = {
  //   id: 0,
  //   TargetMarket: '',
  //   Objective: '',
  //   CurrencyCode: 'MXN',
  //   product: [],
  //   Type: 'Course',
  //   Family: 'Course',
  //   user_id: 0,
  //   category_id: 0,
  //   level_id: 0,
  //   teacher_id: 0,
  //   Title: '',
  //   Slug: 'https://www.learnify.com.mx/curso/example',
  //   Category: 0,
  //   Level: 0,
  //   active: true,
  //   UnitPrice: '0',
  //   Description: '',
  //   ImgFileUrl: ''
  // }

  public categories = [];
  public levels = [];

  currentUser: any;
  // learning: any[] = [];
  // target: any[] = [];
  step = 0;
  // newImageSelected: boolean = false;

  constructor(
    private productService: ProductsService,
    private sanitizer: DomSanitizer,
    private apiService: APIService
  ) {
    // Cargar usuario desde localStorage
    this.loadUserDataFromLocalStorage();
    
    setTimeout(() => {
      this.loadData();
    }, 1500)
  }
  
  // Cargar datos del usuario desde localStorage (igual que el sidebar)
  loadUserDataFromLocalStorage() {
    try {
      const userData = localStorage.getItem('currentUser');
      this.currentUser = userData ? JSON.parse(userData) : { displayName: 'Usuario' };
      
      // Construir displayName si no existe
      if (!this.currentUser.displayName) {
        const firstName = this.currentUser.firstName?.trim();
        const lastName = this.currentUser.lastName?.trim();
        
        if (firstName && lastName) {
          this.currentUser.displayName = `${firstName} ${lastName}`;
        } else if (firstName) {
          this.currentUser.displayName = firstName;
        } else if (lastName) {
          this.currentUser.displayName = lastName;
        } else if (this.currentUser.email) {
          this.currentUser.displayName = this.currentUser.email.split('@')[0];
        } else {
          this.currentUser.displayName = 'Usuario';
        }
      }
      
      // Cargar imagen de perfil
      const cachedBase64 = sessionStorage.getItem('profileImageBase64');
      if (cachedBase64 && cachedBase64.startsWith('data:')) {
        this.currentUser.imgProfile = cachedBase64;
      } else if (!this.currentUser?.imgProfile || !this.isValidImageUrl(this.currentUser.imgProfile)) {
        if (this.currentUser?.profileFileUrl && this.isValidImageUrl(this.currentUser.profileFileUrl)) {
          this.currentUser.imgProfile = this.currentUser.profileFileUrl;
        } else {
          this.currentUser.imgProfile = 'assets/images/user.png';
        }
      }
      
      // Cargar perfil actualizado de la API
      this.loadProfileFromAPI();
      
    } catch (error) {
      console.error('❌ Error al cargar datos del usuario:', error);
      this.currentUser = { displayName: 'Usuario', imgProfile: 'assets/images/user.png' };
    }
  }
  
  // Cargar perfil desde la API
  loadProfileFromAPI() {
    this.apiService.getProfile().subscribe({
      next: (response: any) => {
        if (response && response.success) {
          const userData = response.data;
          
          // Construir displayName
          const firstName = userData.firstName?.trim();
          const lastName = userData.lastName?.trim();
          
          if (firstName && lastName) {
            userData.displayName = `${firstName} ${lastName}`;
          } else if (firstName) {
            userData.displayName = firstName;
          } else if (lastName) {
            userData.displayName = lastName;
          } else if (userData.email) {
            userData.displayName = userData.email.split('@')[0];
          } else {
            userData.displayName = 'Usuario';
          }
          
          // Construir imagen
          let imageUrl = '';
          if (userData.profileImage?.base64) {
            imageUrl = `data:image/jpeg;base64,${userData.profileImage.base64}`;
          } else if (userData.profileFileUrl && this.isValidImageUrl(userData.profileFileUrl)) {
            imageUrl = userData.profileFileUrl;
          } else {
            imageUrl = 'assets/images/user.png';
          }
          
          this.currentUser = {
            ...this.currentUser,
            ...userData,
            imgProfile: imageUrl
          };
          
          if (imageUrl?.startsWith('data:')) {
            try {
              sessionStorage.setItem('profileImageBase64', imageUrl);
            } catch (e) {
              console.warn('⚠️ No se pudo guardar imagen en sessionStorage:', e);
            }
          }
        }
      },
      error: (error) => {
        console.error('❌ Error al cargar perfil desde la API:', error);
      }
    });
  }
  
  // Validar URL de imagen
  isValidImageUrl(url: string): boolean {
    if (!url) return false;
    if (url.startsWith('data:image')) return true;
    if (url.startsWith('http://') || url.startsWith('https://')) return true;
    if (url.startsWith('assets/')) return true;
    return false;
  }

  // Manejador de errores para imagen de perfil
  handleProfileImageError(event: any) {
    console.warn('❌ Error al cargar imagen de perfil del usuario, usando placeholder');
    event.target.src = 'assets/images/user.png';
    // Actualizar currentUser para que no intente cargar la imagen fallida de nuevo
    if (this.currentUser) {
      this.currentUser.imgProfile = 'assets/images/user.png';
    }
  }

  // Manejador de errores para imagen de portada del curso
  handleImageError(event: any) {
    console.warn('❌ Error al cargar imagen de portada del curso, usando placeholder');
    event.target.src = 'assets/images/placeholder.png';
  }

  // Método para obtener la imagen de preview del curso
  // Prioridad: previewImg (base64 del usuario) > responseImgFile (URL del backend) > course.ImgFileUrl (URL guardada)
  getImagePreview(): string {
    // 1. Si hay una imagen seleccionada por el usuario (base64)
    if (this.previewImg && this.previewImg.base) {
      console.log('🖼️ Usando previewImg (imagen seleccionada por el usuario)');
      return this.previewImg.base;
    }
    
    // 2. Si hay una imagen subida al backend
    if (this.responseImgFile) {
      console.log('🖼️ Usando responseImgFile (imagen del backend)');
      return this.responseImgFile;
    }
    
    // 3. Si hay una imagen guardada en el curso
    if (this.course?.ImgFileUrl) {
      console.log('🖼️ Usando course.ImgFileUrl (imagen guardada)');
      return this.course.ImgFileUrl;
    }
    
    // 4. Sin imagen disponible
    console.log('⚠️ No hay imagen disponible');
    return '';
  }

  checkButtonState() {
    if (this.requireAllFields) {
      this.isButtonDisabled = !(
        this.course.Title &&
        this.course.Description &&
        this.course.ImgFileUrl &&
        this.course.UnitPrice &&
        this.course.Category &&
        this.course.Level &&
        this.learning.length > 0 &&
        this.target.length > 0
      );
    } else {
      this.isButtonDisabled = !(this.course.Title && this.course.Title.trim().length > 0);
    }
  }


  removeTarget(fruit: any): void {
    const index = this.target.indexOf(fruit);
    if (index >= 0) {
      this.target.splice(index, 1);
    }
    this.checkButtonState();  // Verifica el estado del botón
  }

  saveProduct() {
    this.checkButtonState();  // Verifica el estado del botón

    if (this.isButtonDisabled) {
      Notiflix.Notify.warning('Por favor complete todos los campos requeridos y suba una imagen.');
      return;  // No continuar si el botón está deshabilitado
    }
    const target = this.target.map((t: any) => { return t.name })
    const objetive = this.learning.map((t: any) => { return t.name })

    this.course.id = this.productId;
    this.course.user_id = this.currentUser.id;
    this.course.teacher_id = this.currentUser.id;
    this.course.category_id = this.course.Category;
    this.course.level_id = this.course.Level;
    this.course.TargetMarket = target.join(",");
    this.course.Objective = objetive.join(",");
    this.course.Slug = this.course.Slug.split("/").pop();
    this.productService.updateCourse2(this.productId, this.course).subscribe((data: any) => {
      Notiflix.Notify.success('Guardado con exito');
      this.notifyParent.emit(this.course);
    });
  }

  addTarget(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      this.target.push({ name: value.trim() });
    }

    if (input) {
      input.value = '';
    }
    this.checkButtonState();  // Verifica el estado del botón
  }

  remove(fruit: any): void {
    const index = this.learning.indexOf(fruit);
    if (index >= 0) {
      this.learning.splice(index, 1);
    }
    this.checkButtonState();  // Verifica el estado del botón
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      this.learning.push({ name: value.trim() });
    }

    if (input) {
      input.value = '';
    }
    this.checkButtonState();  // Verifica el estado del botón
  }

  selectCategory(event) {
    this.categorySelected = this.categories.find(cat => cat.id === parseInt(event.target.value));
    this.checkButtonState();  // Verifica el estado del botón
  }

  selectLevel(event) {
    this.levelSelected = this.levels.find(cat => cat.id === parseInt(event.target.value));
    this.checkButtonState();  // Verifica el estado del botón
  }

  async loadData() {
    this.currentUser = JSON.parse(localStorage['currentUser']);
    let catalogs = this.productService.getCatalogsName('Category');
    this.categories = await lastValueFrom(catalogs);

    catalogs = this.productService.getCatalogsName('Level');
    this.levels = await lastValueFrom(catalogs);

    const product = this.productService.getProduct(this.productId);
    const productData = await lastValueFrom(product);

    const productInfo = productData;

    this.categorySelected = productInfo.Category ?? null;
    this.levelSelected = productInfo.Level ?? null;
    this.responseImgFile = productInfo.ImgFileUrl || '';
    this.course.Category = productInfo ? productInfo.category_id : '';
    this.course.Level = productInfo ? productInfo.level_id : '';
    this.course.Title = productInfo ? productInfo.Title : '';
    this.course.Description = productInfo ? productInfo.Description : '';
    this.course.UnitPrice = productInfo ? productInfo.UnitPrice : '';
    this.course.ImgFileUrl = productInfo ? productInfo.ImgFileUrl : '';
    this.learning = productInfo ? productInfo.Objective ? productInfo.Objective.split(",").map((o: any) => { return { name: o } }) : [] : [];
    this.target = productInfo ? productInfo.TargetMarket ? productInfo.TargetMarket.split(",").map((o: any) => { return { name: o } }) : [] : [];

    this.course.Slug = 'https://www.learnify.com.mx/curso/' + productInfo ? productInfo.Slug : 'example';
    this.course.id = productInfo ? productInfo.id : null;
  }

  onSelectImages(event) {
    this.imagesX = [];
    this.imagesX.push(...event.addedFiles);
    this.file = this.imagesX[0];
    this.newImageSelected = true;  // Marcamos que una nueva imagen ha sido seleccionada

    if (this.file) {
      const formData = new FormData();
      formData.append('file', this.file);
      formData.append('type', 'images');

      this.productService.uploadFile2(formData)
        .subscribe(resolve => {
          if (resolve.FileUrl !== null) {
            // Actualizamos el curso con la nueva URL de la imagen
            this.responseImgFile = resolve.ImageUrl;
            this.course.ImgFileUrl = resolve.ImageUrl;  // <- Aquí nos aseguramos de que la URL se guarde en el curso
            this.checkButtonState();  // Verifica el estado del botón

            const body = {
              id: this.productId,
              ImgFileUrl: resolve.ImageUrl
            };

            this.productService.updateCourse2(this.productId, body).subscribe((data: any) => {
              console.log("Imagen guardada correctamente.");
            });
          }
        });
    }

    // Previsualizamos la imagen seleccionada
    this.viewBase64(this.file).then(image => {
      this.previewImg = image;
    });

    this.ImgfileName = this.file.name;
  }

  // Método para eliminar una imagen seleccionada
  removeImage(file: File) {
    // Filtrar el array de imágenes eliminando la que coincide con el archivo seleccionado
    this.imagesX = this.imagesX.filter(img => img !== file);

    // Si eliminamos la imagen seleccionada, restablecemos el estado
    if (this.imagesX.length === 0) {
      this.newImageSelected = false;
      this.course.ImgFileUrl = '';  // Borrar la URL de la imagen en el curso
      this.responseImgFile = '';    // Limpiar la URL de la imagen cargada
      this.file = null;  // Limpiar la referencia de la imagen actual
    }
    this.checkButtonState();  // Verifica el estado del botón
  }


  // Función para remover la imagen existente y mostrar el dropzone
  removeExistingImage() {
    this.course.ImgFileUrl = null; // Removemos la URL de la imagen guardada
    this.newImageSelected = false; // Permitimos que el dropzone se muestre
    this.responseImgFile = null; // Limpiamos la URL de la imagen cargada
  }

  generateSlug(event) {
    const value = event.target.value;
    const newString = value.toString().toLowerCase().replace(/[^A-Z0-9]/ig, "-");
    this.course.Slug = 'https://www.learnify.com.mx/curso/' + newString;
  }

  viewBase64 = async ($event: any) => new Promise((resolve, reject) => {
    try {
      const unsafeImg = window.URL.createObjectURL($event);
      const image = this.sanitizer.bypassSecurityTrustUrl(unsafeImg);
      const reader = new FileReader();
      reader.readAsDataURL($event);
      reader.onload = () => {
        resolve({
          base: reader.result
        });
      };
      reader.onerror = error => {
        resolve({
          base: null
        });
      };
    } catch (e) {
      return null;
    }
  })

  // ==================== FUNCIONES PARA EL PLAN DE ESTUDIO RESUMIDO ====================
  
  getModulosCount(): number {
    return this.modulos ? this.modulos.length : 0;
  }

  getLeccionesCount(): number {
    if (!this.modulos) return 0;
    return this.modulos.reduce((total, modulo) => total + (modulo.Topics?.length || 0), 0);
  }

  getCompletionPercentage(): number {
    if (!this.modulos || this.modulos.length === 0) return 0;
    
    let totalLessons = 0;
    let uploadedLessons = 0;
    
    this.modulos.forEach(modulo => {
      if (modulo.Topics && modulo.Topics.length > 0) {
        modulo.Topics.forEach((topic: any) => {
          totalLessons++;
          if (topic.uploaded) {
            uploadedLessons++;
          }
        });
      }
    });
    
    return totalLessons > 0 ? Math.round((uploadedLessons / totalLessons) * 100) : 0;
  }

  getModulos(): any[] {
    return this.modulos || [];
  }

  isModuleCompleted(modulo: any): boolean {
    if (!modulo.Topics || modulo.Topics.length === 0) return false;
    return modulo.Topics.every((topic: any) => topic.uploaded);
  }

}

